<section class="landing-banner d-flex align-items-start" [ngClass]="{ stripMarginLandingAdded: stripMargin,'subscribe-strip-margin-landing': shouldShowTrialBanner }"
  id="tender_location">
  <div class="container-xl  mt-5 pt-4">
    <div class="row">
      <div class="col-lg-6 text-left ">
        <div class="landing-banner-left">
          <h1>
            TenderShark: Your Ultimate App <br />
            for Government Tenders
          </h1>
          <h2>
            Discover India's vast tender opportunities. <br />
            Download for FREE!
          </h2>
        </div>
        <a class="playstore-icon" href="">
          <img class="play-icon" src="./assets/images/landing_google_play_image.webp"
            alt="TenderShark - Google Play Store" />
        </a>
        <ul class="tender-count-section">
          <li>
            <span class="tender-count">40681</span>
            <span class="tender-count-label">Active <br> Tenders</span>
          </li>
          <li>
            <span class="tender-count">542</span>
            <span class="tender-count-label">Opening <br> Today</span>
          </li>
          <li>
            <span class="tender-count">4064</span>
            <span class="tender-count-label">Closing <br> Today</span>
          </li>
        </ul>
      </div>
    </div>
  </div>
</section>
<section class="app-link-section">
  <div class="container-xl text-center">
    <div class="row">
      <div class="col-xl-5 col-12 mb-15 app-link-column-1">
        <img class="d-block d-lg-none" src="./assets/images/app_qr_code.webp" alt="Scan the QR code for TenderShark App" />
        <div>
          <h3>
            Get TenderShark on <br />
            Your Device- It's Free!
          </h3>
          <h4>
            Scan the QR code or Enter your phone number <br />
            to receive the TenderShark download link via SMS.
          </h4>
        </div>
      </div>
      <div class="col-xl-7 col-12 mb-15 app-link-column-2">
        <div class="send-link-section">
          <img class="d-none d-lg-block" src="./assets/images/app_qr_code.webp" alt="Scan the QR code for TenderShark App" />
          <div class="link-position-relative d-none d-lg-block">
            <div class="vertical-divider">
              <div class="center-element">OR</div>
            </div>
          </div>
          <span class="or-horizontal-divider">OR</span>
          <div class="link-form-group">
            <div class="h-100" action="">
              <input type="text" [(ngModel)]="mobileNumber" class="form-control input-1 mb-20"
                placeholder="Mobile Number" maxlength="10" (input)="onInputChange()"
                [ngClass]="{'is-invalid': !isNumeric(mobileNumber)}" (keypress)="restrictNonNumeric($event)" />

              <button class="btn btn-danger view-details-btn view-details-btn-width"
                [disabled]="!isSignupButtonEnabled || successfullShow" (click)="sendLink()" type="button">
                <span class="d-flex"> Send Link</span>
              </button>

              <!-- <input class="form-control" placeholder="Enter your number" type="text" /> -->
              <!-- <a type="button" class="btn btn-danger view-details-btn view-details-btn-width" href=""><span
                  class="d-flex" (click)="sendLink()"> Send Link</span></a> -->
            </div>
          </div>
          <!-- <div *ngIf="successfullShow" class="link-form-group">successfullShow"
            <div class="h-100" action="">
              App link sent successfully to your mobile number
            </div>
          </div> -->
        </div>
      </div>
    </div>
  </div>
</section>
<section class="app-features pt-100 ">
  <div class="container-xl text-center">
    <h3 class="section-heading-5">Empowering You with Cutting-Edge Features</h3>
    <h4 class="section-sub-heading-5 mb-50">
      Empowering You with Cutting-Edge Features
    </h4>
    <div class="row justify-content-center featuers-columns">
      <div class="col-xl-3 col-6 mb-15">
        <div class="card card-13">
          <div class="card-body text-start">
            <img src="./assets/images/one_Place_Icon.webp" alt="Access all Tenders at One Place" />
            <span class="solution-card-heading">Access all Tenders at One Place</span>
          </div>
        </div>
      </div>
      <div class="col-xl-3 col-6 mb-15">
        <div class="card card-13">
          <div class="card-body">
            <img src="./assets/images/free_cost_icon.webp" alt="Free forever Zero cost" />
            <span class="solution-card-heading">Free forever Zero cost</span>
          </div>
        </div>
      </div>
      <div class="col-xl-3 col-6 mb-15">
        <div class="card card-13">
          <div class="card-body">
            <img src="./assets/images/unlimited_docs_Icon.webp" alt="Unlimited document downloads" />
            <span class="solution-card-heading">Unlimited document downloads</span>
          </div>
        </div>
      </div>
      <div class="col-xl-3 col-6 mb-15">
        <div class="card card-13">
          <div class="card-body">
            <img src="./assets/images/mobile_whatsapp_icon.webp" alt="Tender alerts over WhatsApp" />
            <span class="solution-card-heading">Tender alerts over WhatsApp</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<section class="app-features pt-100 mb-100 pb-100">
  <div class="container-xl text-center">
    <h3 class="section-heading-5">A Closer Look at Why We're the Best</h3>
    <h4 class="section-sub-heading-5 mb-50">Get the App and Experience It!</h4>

    <div class="row justify-content-center steps-columns">
      <div class="col-lg-4 mb-15">
        <h4 class="section-sub-heading-5 mb-50">
          Enhanced <strong> User Interface </strong> with <br />
          <strong> Advanced Search </strong> Filters
        </h4>
        <img class="img-fluid" src="./assets/images/app_ui_1.jpg" alt="TenderShark App - Enhanced User Interface with
        Advanced Search Filters" />
      </div>
      <div class="col-lg-4 mb-15">
        <h4 class="section-sub-heading-5 mb-50">
          <strong> Tender Details </strong> with Document <br />
          and <strong> Improved Security </strong>
        </h4>
        <img class="img-fluid d-none d-lg-block" src="./assets/images/app_ui_2.jpg" alt="TenderShark App - Tender Details with Document
        and Improved Security" />
        <img class="img-fluid d-block d-lg-none" src="./assets/images/app_ui_m_2.jpg" alt="TenderShark App - Tender Details with Document
        and Improved Security" />
      </div>
      <div class="col-lg-4 mb-15">
        <h4 class="section-sub-heading-5 mb-50">
          Latest <strong> Tender Alerts </strong> with <br />
          Unlimited <strong> Document Downloads </strong>
        </h4>
        <img class="img-fluid" src="./assets/images/app_ui_3.jpg" alt="TenderShark App - Latest Tender Alerts with
        Unlimited Document Downloads" />
      </div>
    </div>
  </div>
</section>
<!-- <app-keywords-section></app-keywords-section> -->